<script>
	import { link } from 'svelte-spa-router';
	
	export let menuOpen = false;
	
	// 메뉴 항목 클릭 시 메뉴를 닫는 함수
	function closeMenu() {
		menuOpen = false;
	}
</script>

<header>
	<div class="navbar">
		<div class="popup-menu {menuOpen ? 'active' : ''}">
			<div class="bg"></div>
			<div class="top-manu">
				<ul class="popup-main-menu">
					<li><a href="/" use:link on:click={closeMenu}>Home</a></li>
					<li><a href="/About" use:link on:click={closeMenu}>About</a></li>
					<li><a href="/Academic" use:link on:click={closeMenu}>Academic</a></li>
					<li><a href="/Stack" use:link on:click={closeMenu}>Stack</a></li>
					<li><a href="/Portfolio" use:link on:click={closeMenu}>Portfolio</a></li>
					<li><a href="/Career" use:link on:click={closeMenu}>Career</a></li>
					<li><a href="/Contact" use:link on:click={closeMenu}>Contact</a></li>
				</ul>  
			</div>
		</div>
		<div class="navbar__button">
			<input id="toggle-button" type="checkbox" bind:checked={menuOpen} />
			<label class="line" for="toggle-button">
				<div class="top"></div>
				<div class="middle"></div>
				<div class="bottom"></div>
			</label>
		</div>
	</div>
</header>

<style>
	header {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 1000;
		height: 60px;
		background-color: #000000;
	}

	.navbar {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.navbar__button {
		position: absolute;
		right: 18px;
		top: 18px;
		z-index: 1001;
		display: block;
	}

	.line {
		display: block;
		width: 32px;
		height: 32px;
		position: relative;
		cursor: pointer;
	}

	.line div {
		background-color: #ffffff;
		width: 32px;
		height: 2px;
		position: absolute;
		border-radius: 2px;
		transition: all 0.2s ease-in-out;
	}

	.line .top {
		top: 8px;
	}

	.line .middle {
		top: 16px;
	}

	.line .bottom {
		top: 24px;
	}

	#toggle-button {
		display: none;
	}

	#toggle-button:checked + .line .top {
		transform: rotate(45deg);
		top: 16px;
	}

	#toggle-button:checked + .line .middle {
		transform: rotate(-45deg);
		top: 16px;
	}

	#toggle-button:checked + .line .bottom {
		transform: scale(0);
	}

	.popup-menu {
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		display: none;
		color: #ffffff;
	}

	.popup-menu.active {
		display: block;
	}

	.popup-menu .bg {
		background-color: #000000;
		position: absolute;
		top: 60px;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 0;
	}

	.popup-menu .top-manu {
		width: 100%;
		position: absolute;
		top: 80px;
		left: 10px;
		z-index: 1;
	}

	.popup-menu .top-manu .popup-main-menu {
		list-style: none;
		padding-left: 0;
		color: #ffffff;
	}

	.popup-menu .top-manu .popup-main-menu li {
		padding: 8px 12px;
		font-size: 21px;
		font-weight: 600;
		line-height: 1.2;
	}

	.popup-menu .top-manu .popup-main-menu a {
		color: #ffffff;
		transition: color 0.3s ease;
	}

	.popup-menu .top-manu .popup-main-menu a:hover {
		color: #cccccc;
	}

	a {
		text-decoration: none;
		color: inherit;
	}
</style>